import { LineSegments2 } from "./LineSegments2.js";
import { LineGeometry } from "./LineGeometry.js";
import { LineMaterial } from "./LineMaterial.js";
class Line2 extends LineSegments2 {
  constructor() {
    let geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new LineGeometry();
    let material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new LineMaterial({
      color: Math.random() * 16777215
    });
    super(geometry, material);
    this.isLine2 = true;
    this.type = "Line2";
  }
}
export { Line2 };